import { Modal as UiKitModal } from '@ui-kit/components/Modal/Modal';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

type Props = Omit<ComponentProps<typeof UiKitModal>, 'closeButtonAriaLabel'>;

export const Modal = ({ children, ...restProps }: Props) => {
  const { t } = useTranslation('Common');

  return (
    <UiKitModal closeButtonAriaLabel={t('close')} {...restProps}>
      {children}
    </UiKitModal>
  );
};
